import type { ReactNode } from 'react';
import { StatusBadge } from './ui.js';
import type { Tone } from './ui.js';

/**
 * Stav textem a značkou: ikonu podle významu (fajfka, varování) už přidává styl `.pill`,
 * proto tu žádná další není. Slouží jako jednotný vstup pro obrazovky fáze 2B.
 */
export function Badge({ tone, children }: { tone: Tone; children: ReactNode }): JSX.Element {
  return <StatusBadge tone={tone}>{children}</StatusBadge>;
}
